import { ProofOfReserve } from '@flipster/apis/v1/support/types';
import { FormattedMessage } from '@flipster/i18n';
import { Spinner } from '@flipster/react/design-system/spinner';
import Formatted from '@flipster/react/design-utils/formatted';
import { css } from '@flipster/styled-system/css';
import { center, circle, divider, hstack } from '@flipster/styled-system/patterns';
import Num from '@flipster/utils/num';

const BalancePrecision = 3;

interface Props {
  isLoading: boolean;
  item: ProofOfReserve;
}

export const CardItem = ({ isLoading, item }: Props) => {
  return (
    <li
      className={css({
        minH: 214,
        py: 20,
        px: 16,
        bgColor: 'background.default.level-1',
        rounded: 8,
      })}
    >
      {isLoading ? (
        <div className={center({ w: '100%', h: '100%' })}>
          <Spinner size={24} />
        </div>
      ) : (
        <div>
          <div className={hstack({ justify: 'space-between', mb: 8 })}>
            <p className={hstack({ textStyle: 'Title/S', color: 'inverse.white', gap: 6 })}>
              {item.currency}
              <span className={css({ textStyle: 'Text/L/Strong', color: 'content.default.level-1' })}>
                <FormattedMessage id='Autogen_common.r251126.s_Ratio' />
              </span>
            </p>
            <div className={circle({ size: 32 })}>
              <img src={item.icon} alt={`${item.currency} icon`} width={32} height={32} />
            </div>
          </div>
          <div className={css({ textStyle: 'Title/M', mb: 12 })}>
            <Formatted.Percent
              value={Num(item.exchNetBalances).dividedBy(item.customerNetBalances).multipliedBy(100).toString()}
              toFixed
            />
          </div>
          <dl
            className={css({
              '& dt': {
                textStyle: 'Text/XS/Regular',
                color: 'content.default.level-2',
                mb: 2,
              },
              '& dd': {
                textStyle: 'Text/L/Monospace/Regular',
                color: 'content.default.level-5',
              },
            })}
          >
            <dt>
              <FormattedMessage id='Autogen_common.r251126.s_Customer_net_balances' />
            </dt>
            <dd>
              <Formatted.Number value={item.customerNetBalances} precision={BalancePrecision} toFixed />
            </dd>
            <hr className={divider({ orientation: 'horizontal', color: 'border.default.level-2', my: 8 })} />
            <dt>
              <FormattedMessage id='Autogen_common.r251126.s_Flipster_net_balances' />
            </dt>
            <dd>
              <Formatted.Number value={item.exchNetBalances} precision={BalancePrecision} toFixed />
            </dd>
          </dl>
        </div>
      )}
    </li>
  );
};
